module.exports = __webpack_public_path__ + "img/10.06751fd0.jpg";